import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import InsuranceTypeModal from './Insurance_Modal';
import { deleteInsuranceType, getInsuranceTypeList } from '../actions/InsuranceActions';
import Alert from 'react-s-alert';
import PaginatorCustom from '../../../../../components/paginationCustom';
import { Field, reduxForm, reset } from 'redux-form';
import { renderTextField } from '../../../../../components/reduxFields';
import SubString from 'add-ellipsis';
import SortingCustom from '../../../../../components/SortingCustom';
import { alertConfirmation, resetFiltersAndSorting } from '../../../../../actions/utilAction';
import Tooltip from '../../../../../components/Tooltip';

class InsuranceTypeList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      insuranceTypeId: null,
    };

    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };
    this.setSortColumn = this.setSortColumn.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSubmitSearch = this.handleSubmitSearch.bind(this);
  }
  loadData(page_number) {
    let searchObj = {
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText || null },
      pageNumber: page_number || 1,
    };
    this.props.getInsuranceTypeList(searchObj);
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadData();
    }
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.deleted_insuranceType && nextProps.deleted_insuranceType !== this.props.deleted_insuranceType) {
      this.loadData();
    }
    if (nextProps.saved_insuranceType && nextProps.saved_insuranceType !== this.props.saved_insuranceType) {
      this.loadData();
    }
  }

  handleReset = () => {
    Alert.closeAll();
    this.loadData();
  };
  handleOpen = () => {
    Alert.closeAll();
    this.setState({ open: true, insuranceTypeId: null });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleAlertClick = (event, insuranceTypeId) => {
    this.props.deleteInsuranceType(insuranceTypeId);
    Alert.closeAll();
  }
  handleDeleteClick = (event, obj) => {
    alertConfirmation('Once you click yes, all the payers linked with this insurance type will get effected. Are you sure you want to delete this insurance type?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: obj.id,
      },
    });
  }

  handleEditClick = (event, obj) => {
    Alert.closeAll();
    this.setState({ open: true, insuranceTypeId: obj.id });
  }

  componentWillUnmount() {
    Alert.closeAll();
  }
  handleSearchChange(event) {
    if (event.target.value.length > 2) {
      this.filter.searchText = event.target.value;
      this.loadData();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
  }
  handleResetButton() {
    Alert.closeAll();
    this.props.dispatch(reset('InsuranceTypeListForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadData();
  }

  handleSubmitSearch() {
    return false;
  }

  renderData(insTypesList) {
    insTypesList = insTypesList || [];

    if (!insTypesList.length) {
      return (
        <tr>
          <td colSpan="4">
            <div className="familydl text-center no-record">{this.props.loading ? 'loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }
    return insTypesList.map((data, index) => {
      return (
        <tr key={index}>
          <td>{data.insuranceType}</td>
          <td>
            {data.description && data.description.length > 0 ?
              <Tooltip Description={data.description} />
              : null}
            {data.description != null && data.description.length > 50 ? SubString(data.description, 50) : data.description != null ? data.description : 'N/A'}</td>
          <td>{data.insuranceCode}</td>
          {this.props.updatePermission || this.props.deletePermission ?
            <td>
              {
                this.props.updatePermission ?
                  <button onClick={(e) => this.handleEditClick(e, data)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
                  : null
              }
              {
                this.props.deletePermission ?
                  <button onClick={(e) => this.handleDeleteClick(e, data)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
                  : null
              }
            </td>
            : null
          }
        </tr>
      );
    });
  }
  render() {
    const { handleSubmit, insuranceTypesList } = this.props;
    let insTypesList = (insuranceTypesList && insuranceTypesList.data) || [];
    let insTypesMeta = (insuranceTypesList && insuranceTypesList.meta) || null;
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    return (
      <div>
        <h2 className="page_title">Manage Insurance Type</h2>
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
            <div className="modalwindow">
              <div className="row">
                <div className="col-sm-5">
                  {this.props.addPermission ?
                    <RaisedButton label="Add Insurance Type" primary={true} onTouchTap={this.handleOpen} />
                    : null
                  }
                </div>
                <div className="col-sm-7">
                  <div className="row end-flex">
                    <div className="col-sm-6 mtm-27">
                      <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSubmitSearch)}>
                        <Field
                          name="InsuranceType"
                          floatingLabelText="Search"
                          maxLength='15'
                          onChange={this.handleSearchChange}
                          component={renderTextField}
                        />
                      </form>
                    </div>
                    <div className="reset-btn col-sm-3 btn_rt">
                      <RaisedButton primary={true} onTouchTap={this.handleResetButton} className="grey_btn">Reset</RaisedButton>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.open ? <InsuranceTypeModal insuranceTypeId={this.state.insuranceTypeId} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="table-responsive mt-15">
                  <table className={tableClass}>
                    <thead>
                      <tr>
                        <th width="30%"><SortingCustom noSort={!insTypesList.length} setSortColumn={this.setSortColumn} columnName='InsuranceType' displayName='Insurance Type' /></th>
                        <th width="40%"><SortingCustom noSort={!insTypesList.length} setSortColumn={this.setSortColumn} columnName='Description' displayName='Description' /></th>
                        <th width="20%"><SortingCustom noSort={!insTypesList.length} setSortColumn={this.setSortColumn} columnName='InsuranceCode' displayName='Insurance Code' /></th>
                        {this.props.updatePermission || this.props.deletePermission ?
                          <th width="10%">Actions</th>
                          : null
                        }
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderData(insTypesList)}
                    </tbody>
                  </table>
                  {insTypesMeta && insTypesMeta['totalPages'] ?
                    <PaginatorCustom data={insTypesMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InsuranceTypeList = reduxForm({
  form: 'InsuranceTypeListForm',
})(InsuranceTypeList);

function mapStateToProps(state) {
  console.log('state......',state.insuranceType);
  console.log("insurancelogin",state.login);
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'MASTERS');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'MASTERS_INSURANCETYPES_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }
  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_INSURANCETYPES_LIST_ADD')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_INSURANCETYPES_LIST_UPDATE')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'MASTERS_INSURANCETYPES_LIST_DELETE')[0].permission : false;

  // End For Role Permission

  return {
    loading: state.insuranceType.loading,
    insuranceTypesList: state.insuranceType.insuranceTypesList,
    insuranceTypeData: state.insuranceType.insuranceTypeData,
    deleted_insuranceType: state.insuranceType.deleted_insuranceType,
    saved_insuranceType: state.insuranceType.saved_insuranceType,
    addPermission: addPermission,
    updatePermission: updatePermission,
    deletePermission: deletePermission,
  };
}
export default connect(mapStateToProps, { getInsuranceTypeList, deleteInsuranceType })(InsuranceTypeList);



// WEBPACK FOOTER //
// ./src/modules/Masters/components/insurance-master/components/index.js